import React, { useEffect, useState } from 'react';
import { Container, Label, Select, Input, Button } from './cssStyles';
import {supabase} from './appDB'


const CategorySelector = ({ selectedCategory, onCategoryChange }) => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      const { data, error } = await supabase.from('sparkcatcherCBO').select('Category');

      if (error) {
        console.error('Error fetching categories:', error);
      } else {
        setCategories(data.map((item) => item.Category));
      }
      setLoading(false);
    };

    fetchCategories();
  }, []);

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    onCategoryChange(value);
    if (value !== 'new') {
      setNewCategory('');
    }
  };

  const handleInputChange = (e) => {
    setNewCategory(e.target.value); // Handle the new value input
  };
  
  const handleAddCategory = async () => {
    if (newCategory && !categories.includes(newCategory)) {
      // eslint-disable-next-line
      const { data, error } = await supabase
        .from('sparkcatcherCBO')
        .insert([{ Category: newCategory }]);

      if (error) {
        console.error('Error adding category:', error);
      } else {
        setCategories((prev) => [...prev, newCategory]);
        onCategoryChange(newCategory);
      }
    }
  };

  return (
    <Container>
      <Label htmlFor="category">Idea Category:</Label>
      {loading ? (
        <p>Loading categories...</p> // Show this while fetching categories
      ) : (
      <Select
        id="category"
        value={selectedCategory}
        onChange={handleCategoryChange}
      >
        <option value="" disabled>Select a category</option>
        {categories.map((category, index) => (
          <option key={index} value={category}>
            {category}
          </option>
        ))}
        <option value="new">Add new option</option> {/* Option for adding new */}
      </Select>
      )}

      {selectedCategory === 'new' && (
        <div>
          <Input
            type="text"
            value={newCategory}
            onChange={handleInputChange}
            placeholder="Type in a new category"
          />
          {newCategory.trim() && (
            <Button onClick={handleAddCategory}>Save category</Button>
          )}
        </div>
      )}
    </Container>
  );
}

export default CategorySelector;
